import React from "react";
import { Link, useParams } from "react-router-dom";
import { BASE_IMAGE_URL } from "../../../utils/services";
import DownloadIcon from "../../../assets/image/DownloadIcon";

const PreviewImage = () => {
  const { id } = useParams();
  const url = `${BASE_IMAGE_URL}/${atob(id)}`;

  document.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });

  return (
    <div className="form-style">
      <div className="prev-head d-flex align-items-center justify-content-end">
        <Link to={url} download className="mb-2">
          <div className="download-btn-container">
            <button type="button" className="btn">
              <DownloadIcon /> Download
            </button>
          </div>
        </Link>
      </div>
      <div className="main text-center">
        <img 
          src={url} 
          alt="Preview" 
          style={{ maxWidth: '100%', maxHeight: '80vh' }}
          className="img-fluid"
        />
      </div>
    </div>
  );
};

export default PreviewImage;